export default "__VITE_ASSET__CXmuKP7$__"